//@ts-check

import { parseHtml } from 'helpers';
// @ts-ignore
import stylesCourse from 'styles/Course.module.scss';
import React from 'react';

const FreeTextMarking = ({ result, title = 'Your Answer' }) => {
  return (
    <>
      <span className="view-page-title">{title} :</span>
      <div className="whiteSpacePre foo freetext-correct-ans">
        <div className={`${result?.dataContent === '' ? 'display-none' : ''}`}>
          <div
            className={
              `${stylesCourse['item-section-normal']}` +
              ` ${stylesCourse['item-section-enabled']}`
            }
            style={{
              // @ts-ignore
              '--labelcolor': '#c1c9d4',
            }}
          >
            <span className="">
              {parseHtml(
                result?.dataContent,
                'px-05 py-05 fill-in-the-blank  mtc-order-width',
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default FreeTextMarking;
